import React from 'react';
import { AlertTriangle, RefreshCw } from 'lucide-react';
import { Button } from './ui/button';

class PoseCameraErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('PoseCamera Error:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="hpme-card p-8 text-center">
          <AlertTriangle className="w-16 h-16 text-yellow-500 mx-auto mb-4" />
          <h3 className="font-secondary font-bold text-xl mb-2">Camera Error</h3>
          <p className="text-zinc-400 mb-4">
            Something went wrong with the camera or pose detection.
          </p>
          <p className="text-xs text-zinc-500 mb-6 font-mono bg-zinc-900 p-2 rounded">
            {this.state.error?.message || 'Unknown error'}
          </p>
          <Button 
            className="hpme-btn-primary"
            onClick={() => {
              this.setState({ hasError: false, error: null });
              window.location.reload();
            }}
          >
            <RefreshCw className="w-4 h-4 mr-2" />
            Reload Page
          </Button>
        </div>
      );
    }

    return this.props.children;
  }
}

export default PoseCameraErrorBoundary;
